const getDefaultValues = (groupDetails, updatedValues) => ({
  groupName: updatedValues?.groupName ?? groupDetails?.name ?? '',
  groupDescription: updatedValues?.groupDescription ?? groupDetails?.description ?? '',
  groupRules: updatedValues?.groupRules ?? groupDetails?.codeOfConduct ?? '',
  allowOrdinancesSharingCheck:
    updatedValues?.allowOrdinancesSharingCheck ?? groupDetails?.types?.includes('ORDINANCE_SHARING') ?? true,
  agreeJoinCheckTree1:
    updatedValues?.agreeJoinCheckTree1 ?? groupDetails?.types?.includes('PRIVATE_PERSON_SHARING') ?? false,
  agreeJoinCheckTree2:
    updatedValues?.agreeJoinCheckTree2 ?? groupDetails?.types?.includes('PRIVATE_PERSON_SHARING') ?? false,
})

export default getDefaultValues
